import { render, staticRenderFns } from "./page-test.vue?vue&type=template&id=d15863a6&scoped=true&"
import script from "./page-test.vue?vue&type=script&lang=js&"
export * from "./page-test.vue?vue&type=script&lang=js&"
import style0 from "./page-test.vue?vue&type=style&index=0&id=d15863a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15863a6",
  null
  
)

export default component.exports